/* eslint-disable import/named */
import React, { Fragment, useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { parse } from 'qs';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { YAHOO_TARGET } from '../constants/yahoo';
import MenuLink from './menu_link';
import {
  webServerHostUrl,
  getAvatarUrlByMemberId
} from '../utilities/url_util';
import { LazyMemberImg } from './Image';
import AreaSwitcher from './AreaSwitcher';
import {
  logout
  // fetchMyTripList,
  // fetchTravelGroupList,
  // eraseTripList
} from '../actions/index';
import { REQUEST } from '../actions/action_types';
import { getRewardPointsBalance } from '../actions/rewardPoints';
import UserBox from './UserBox';
import MobileSideBar from './MobileSideBar';
import SearchHeader from './SearchHeader';
import { MOBILE_WIDTH_POINT } from '../constants/device';
import { MY_REFERRAL_PAGE } from '../constants/routesPath';
import { sendGAEvent } from '../utilities/gaEvent';
import { disableDiscover } from '../utilities/config';
import { isLineBrowser } from '../utilities/device_util';
import useIsTW from './hook/useIsTW';
import useIsJA from './hook/useIsJA';
import useGtag from './hook/useGtag';

const MY_TRIPS_ID = 'MY_TRIPS_ID';
const MY_BOOKINGS_ID = 'MY_BOOKINGS_ID';
const MY_JOURNALS_ID = 'MY_JOURNALS_ID';
const MY_NOTIFICATIONS_ID = 'MY_NOTIFICATIONS_ID';
const TRAVEL_GROUPS_ID = 'TRAVEL_GROUPS_ID';
const INVITATIONS_ID = 'INVITATIONS_ID';
const LOG_IN_ID = 'LOG_IN_ID';
const EXPERIENCES_ID = 'EXPERIENCES_ID';
const DOWNLOAD_FUNLIDAY_ID = 'DOWNLOAD_FUNLIDAY_ID';
const PLAN_A_TRIP_ID = 'PLAN_A_TRIP_ID';
const SETTINGS_ID = 'SETTINGS_ID';
const PROFILE_ID = 'PROFILE_ID';
const CAR_RENTAL_ID = 'CAR_RENTAL_ID';
const SIM_WIFI_ID = 'SIM_WIFI_ID';

const Header = props => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { locale } = useIntl();
  const isTW = useIsTW();
  const isJA = useIsJA();

  const { target: deviceNumber } = useSelector(state => state.init);
  const { state: viewState } = useSelector(state => state.viewState.viewState);
  const { isLogin, data: member } = useSelector(state => state.member);
  const { extras: funPoints } = useSelector(state => state.rewardPoints);
  // const { token: accessToken } = useSelector(state => state.member.accessToken);
  // const { tripListSegmentIndex: myTripsCurrentSegmentIndex } = useSelector(
  //   state => state.tripList
  // );
  const { uploadAvatarStatus } = useSelector(state => state.apiFunlidayStatus);
  const [showMenu, setShowMenu] = useState(false);
  const [showUserBox, setShowUserBox] = useState(false);
  const [avatarUrl, setAvatarUrl] = useState(
    member?._id && getAvatarUrlByMemberId(member._id)
  );

  const userBoxLinks = [
    {
      id: MY_TRIPS_ID,
      isCurrent: false,
      isExternal: false,
      isSsr: false,
      path: '/me/trips',
      textId: 'Trips',
      isHiddenFromYahoo: false,
      isHiddenFromUserBox: false
    },
    {
      id: MY_BOOKINGS_ID,
      isCurrent: false,
      isExternal: false,
      isSsr: false,
      path: '/me/bookings',
      textId: 'Bookings',
      isHiddenFromYahoo: false,
      isHiddenFromUserBox: false
    },
    {
      id: MY_JOURNALS_ID,
      isCurrent: false,
      isExternal: false,
      isSsr: false,
      path: '/me/journals',
      textId: 'Journals',
      isHiddenFromYahoo: false,
      isHiddenFromUserBox: false
    },
    {
      id: MY_NOTIFICATIONS_ID,
      isCurrent: false,
      isExternal: false,
      isSsr: false,
      path: '/me/notifications',
      textId: 'Notifications',
      isHiddenFromYahoo: false,
      isHiddenFromUserBox: false
    },
    {
      id: DOWNLOAD_FUNLIDAY_ID,
      isCurrent: false,
      isExternal: false,
      isSsr: false,
      path: '/download',
      textId: 'Download Funliday',
      isHiddenFromYahoo: true,
      isHiddenFromUserBox: false
    },
    {
      id: EXPERIENCES_ID,
      isCurrent: false,
      isExternal: false,
      isSsr: false,
      path: '/experiences',
      textId: 'Experiences',
      isHiddenFromYahoo: false,
      isHiddenFromUserBox: false
    },
    {
      id: SIM_WIFI_ID,
      isCurrent: false,
      isExternal: false,
      isSsr: true,
      path: '/wifi-sim-card',
      textId: 'Sim-Wifi',
      isHiddenFromYahoo: false,
      isHiddenFromUserBox: true
    },
    {
      id: CAR_RENTAL_ID,
      isCurrent: false,
      isExternal: false,
      isSsr: true,
      path: '/car-rental',
      textId: 'Car rental',
      isHiddenFromYahoo: false,
      isHiddenFromUserBox: true
    },
    {
      id: PLAN_A_TRIP_ID,
      isCurrent: false,
      isExternal: false,
      isSsr: false,
      path: '/me/trips',
      textId: 'Plan a trip',
      isHiddenFromYahoo: false,
      isHiddenFromUserBox: false
    }
  ];

  useEffect(() => {
    setShowUserBox(false);
    setShowMenu(false);
  }, [viewState]);

  useEffect(() => {
    if (isLogin && member) {
      dispatch(getRewardPointsBalance());
    }
    if (member?.imageUrl) {
      setAvatarUrl(member?.imageUrl);
    }
  }, [isLogin]);

  useEffect(() => {
    if (uploadAvatarStatus === REQUEST.SUCCESS && member?.imageUrl) {
      setAvatarUrl(member?.imageUrl);
    }
  }, [viewState]);

  // slide menu button for mobile version
  const onMenuClick = e => {
    if (handleEnterSpaceKey(e) === false) return;
    setShowMenu(!showMenu);
  };

  const onMenuItemClick = e => {
    if (handleEnterSpaceKey(e) === false) return;
    const selectedId = parseInt(e.currentTarget.dataset.id, 10);
    setShowMenu(false);
    setShowUserBox(false);
    if (
      selectedId === MY_TRIPS_ID ||
      selectedId === TRAVEL_GROUPS_ID ||
      selectedId === INVITATIONS_ID
    ) {
      // sendFetchMyTripListAction(selectedId, 0, TRIP_LIST_PAGE_COUNT);
      // dispatch action to update selected segment id for my tirps
      // props.headerMenuSelected(selectedId, null);
      // fetchMyTripList
      // fetchTravelGroupList
    }
  };

  const onUserBoxItemClick = e => {
    if (handleEnterSpaceKey(e) === false) return;
    setShowMenu(false);
    setShowUserBox(false);
  };

  const onSignOutClick = e => {
    if (handleEnterSpaceKey(e) === false) return;
    dispatch(logout());
    // ga
    sendGAEvent({
      category: 'UI_ACTION',
      action: 'sign out button click'
    });
  };

  // show profile popup
  const onProfileIconClick = e => {
    if (handleEnterSpaceKey(e) === false) return;
    setShowMenu(false);
    setShowUserBox(!showUserBox);
    // ga
    sendGAEvent({
      category: 'UI_ACTION',
      action: 'profile button click'
    });
  };

  /** @summary a11y snippet, only handles 'Enter' or 'Space' */
  const handleEnterSpaceKey = e => {
    if (e instanceof KeyboardEvent && e.key !== 'Enter' && e.key !== ' ') {
      return false;
    }
    return true;
  };

  // requests
  // const sendFetchMyTripListAction = (segmentIndex, skip, limit) => {
  //   const {
  //     member: { _id: memberObjectId },
  //     accessToken,
  //     myTripsCurrentSegmentIndex
  //   } = props;
  //   if (myTripsCurrentSegmentIndex === segmentIndex) {
  //     return;
  //   }
  //   if (segmentIndex === 1) {
  //     eraseTripList();
  //     fetchMyTripList(accessToken, memberObjectId, skip, limit);
  //   } else if (segmentIndex === 2) {
  //     eraseTripList();
  //     fetchTravelGroupList(accessToken, memberObjectId, skip, limit);
  //   }
  // };

  const getQueryString = () => {
    if (!location) {
      return null;
    }
    const query = parse(location.search.substr(1));
    if (query.hl) {
      return `?hl=${query.hl}`;
    }
    return null;
  };

  const openLoginByExternalBrowser = () => {
    window.open(`${webServerHostUrl()}login?openExternalBrowser=1`, '_blank');
  };

  // download icons
  // const renderAppleDownloadIcon = () => (
  //   <li key="appleicon">
  //     <a
  //       href="https://itunes.apple.com/tw/app/funliday-Travel%20Planner/id905768387"
  //       target="_blank"
  //       rel="noopener noreferrer"
  //       className="branding-download-ios"
  //     >
  //       <div />
  //     </a>
  //   </li>
  // );

  // const consrenderGoogleDownloadIcon = () => (
  //   <li key="googleicon">
  //     <a
  //       href="https://play.google.com/store/apps/details?id=com.funliday.app"
  //       target="_blank"
  //       rel="noopener noreferrer"
  //       className="branding-download-android"
  //     >
  //       <div />
  //     </a>
  //   </li>
  // );

  /**
   *
   * @param {*} id - the node id
   * @param {*} className - className
   * @param {*} path - location.pathname
   * @param {*} search - location.search
   * @param {*} textId - intl textId
   * @param {*} onClick - onClick()
   * @param {*} isExternal - if the page is external
   * @param {*} isSsr - if the page is SSR rendered
   * @param {*} isCurrent - return true if the page is current
   * @returns React.Component <MenuLink/>
   *
   * @example
   * // example function as follows:
   * renderLengend() {
   *   const queryString = getQueryString();
   *   return renderMenuLink(
   *      LEGEND_ID, // id - the node id
   *      null, // className
   *      '/lengend', // path - location.pathname
   *      queryString, // search - location.search
   *      'Lengend', // textId - intl textId
   *      onMenuItemClick, // onClick()
   *      false, // isExternal - if the page is external
   *      false, // isSsr - if the page is SSR rendered
   *     location.pathname === '/legend', // isCurrent
   *   );
   * }
   */
  const renderMenuLink = (
    id,
    className,
    path,
    search,
    textId,
    onClick,
    isExternal,
    isSsr,
    isCurrent
  ) => (
    <MenuLink
      id={id}
      className={className}
      path={path}
      search={search}
      textId={textId}
      onClick={onClick}
      isExternal={isExternal}
      isSsr={isSsr}
      isCurrent={isCurrent}
    />
  );

  /**
   * @name renderSignInMenu
   * @summary render sign in and sign out menu
   */
  const renderSignInMenu = border => {
    const checkPath = login => {
      if (login) return null;
      return '/login';
    };

    useGtag();

    const checkPathName = pathname => pathname === '/login';

    const className = border ? 'rightBorder' : null;
    const path = checkPath(isLogin);
    const textId = isLogin ? 'Sign out' : 'Sign in';
    const onClick = isLogin ? onSignOutClick : onMenuItemClick;
    const queryString = getQueryString();
    if (isLogin) {
      // sign out link
      return (
        <li
          className="header-user"
          onClick={onProfileIconClick}
          onKeyDown={onProfileIconClick}
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex={0}
          style={{ marginLeft: '6px' }}
        >
          <div className="header-user-wrap">
            <span className="header-user-image-wrap">
              <LazyMemberImg
                className="header-user-image"
                src={avatarUrl}
                title="profile"
                alt="profile"
              />
            </span>
          </div>
        </li>
      );
    }

    if (isLineBrowser()) {
      return (
        <li className={LOG_IN_ID}>
          <div
            role="button"
            tabIndex={0}
            onClick={openLoginByExternalBrowser}
            onKeyDown={openLoginByExternalBrowser}
          >
            <FormattedMessage id={textId} description={textId} />
          </div>
        </li>
      );
    }
    return renderMenuLink(
      LOG_IN_ID,
      className,
      path,
      queryString,
      textId,
      onClick,
      false,
      false,
      checkPathName(location.pathname)
    );
  };

  /**
   * @name renderPlanATrip
   * @summary menu link wrapper for myTrip
   */
  const renderPlanATrip = () => {
    const MY_TRIPS_PATH = '/me/trips';
    const queryString = getQueryString();

    if (location.pathname.indexOf(MY_TRIPS_PATH) === -1) {
      return renderMenuLink(
        PLAN_A_TRIP_ID,
        null,
        '/me/trips',
        queryString,
        'Plan a trip',
        onMenuItemClick,
        false,
        false
      );
    }
    return null;
  };

  // 等五一連假結束就要拿掉 - 先註解不確定之後端午連假是否會繼續用到
  // const renderHeatmap = () => {
  //   const queryString = getQueryString();
  //   return renderMenuLink(
  //     HEATMAP_ID,
  //     null,
  //     '/heatmap',
  //     queryString,
  //     '五一連假熱門景點預測',
  //     onMenuItemClick,
  //     false,
  //     false,
  //   );
  // }

  const renderAreaSwitch = () => <AreaSwitcher onMenuClick={onMenuClick} />;

  // 目前 Experiences page 僅秀在 zh-tw 語系網站
  const renderExperiences = () => {
    const queryString = getQueryString();
    return renderMenuLink(
      EXPERIENCES_ID,
      null,
      '/experiences',
      queryString,
      'Experiences',
      onMenuItemClick,
      false,
      false,
      location.pathname === '/experiences'
    );
  };

  /**
   * @name renderSimWifiRental
   * @summary menu link wrapper for SIM/ Wifi
   */
  const renderSimWifiRental = () => {
    const queryString = getQueryString();
    return renderMenuLink(
      SIM_WIFI_ID,
      null,
      '/wifi-sim-card',
      queryString,
      'Sim-Wifi',
      onMenuItemClick,
      false,
      true,
      location.pathname === '/wifi-sim-card'
    );
  };

  /**
   * @name renderCarRental
   * @summary menu link wrapper for car rental
   */
  const renderCarRental = () => {
    const queryString = getQueryString();
    return renderMenuLink(
      CAR_RENTAL_ID,
      null,
      '/car-rental',
      queryString,
      'Car rental',
      onMenuItemClick,
      false,
      true,
      location.pathname === '/car-rental'
    );
  };

  /**
   * @name renderDiscover
   * @summary menu link wrapper for Discover
   * @description temporary: waiting for release discover feature
   */
  const renderDiscover = queryString => {
    if (disableDiscover()) {
      return null;
    }

    return renderMenuLink(
      DOWNLOAD_FUNLIDAY_ID,
      null,
      '/download',
      queryString,
      'Download Funliday',
      onMenuItemClick,
      false,
      false,
      location.pathname === '/download'
    );
  };

  /**
   * @name renderHeaderMenu
   * @summary menu for landing page
   * - logged in : QR Code / My Trips / Profile(Sign out)
   * - guest : QR Code / Sign in
   */
  const renderHeaderMenu = () => {
    const queryString = getQueryString();
    const headerMenu = [];

    // my trips
    if (isLogin) {
      headerMenu.push(
        renderMenuLink(
          MY_TRIPS_ID,
          null,
          '/me/trips',
          queryString,
          'Trips',
          onMenuItemClick,
          false,
          false,
          location.pathname === '/me/trips' ||
            location.pathname === '/itinerary'
        )
      );

      headerMenu.push(
        renderMenuLink(
          MY_NOTIFICATIONS_ID,
          null,
          '/me/notifications',
          queryString,
          'Notifications',
          onMenuItemClick,
          false,
          false,
          location.pathname === '/me/notifications'
        )
      );
    }

    // heatmap, discover, qrcode, tutorial, signin menu
    // if (locale.indexOf('zh') !== -1) {  // 先註解不確定之後端午連假是否會繼續用到
    //   headerMenu.push(renderHeatmap());
    // }

    // 目前 Experiences page 僅秀在 zh-tw 語系網站
    if (
      locale.indexOf('zh-tw') !== -1 ||
      locale.indexOf('zh_tw') !== -1 ||
      locale === 'zh'
    ) {
      headerMenu.push(renderExperiences());
      headerMenu.push(renderSimWifiRental());
      headerMenu.push(renderCarRental());
    }

    if (deviceNumber !== YAHOO_TARGET) {
      headerMenu.push(renderDiscover(queryString));
    }
    headerMenu.push(renderPlanATrip());
    headerMenu.push(renderAreaSwitch());

    if (isLogin) {
      headerMenu.push(
        renderMenuLink(
          SETTINGS_ID,
          null,
          '/me/settings',
          queryString,
          'Settings',
          onMenuItemClick,
          false,
          false,
          location.pathname === '/me/settings'
        )
      );

      headerMenu.push(
        renderMenuLink(
          PROFILE_ID,
          null,
          `/${member.userid}`,
          queryString,
          'Profile',
          onMenuItemClick,
          false,
          false,
          location.pathname === `/${member.userid}`
        )
      );
    }

    headerMenu.push(renderSignInMenu(false));

    if (
      !isLogin &&
      deviceNumber === YAHOO_TARGET &&
      window.innerWidth <= MOBILE_WIDTH_POINT
    ) {
      headerMenu.push(
        renderMenuLink(
          'YAHOO_FUNLIDAY_INDEX_ID',
          null,
          '/',
          queryString,
          'Homepage',
          onMenuItemClick,
          false,
          false,
          location.pathname === '/'
        )
      );
    }

    return (
      <ul>
        {headerMenu.map((link, index) => {
          // HACK: 等五一連假結束後就復原
          const key =
            link && link.props && link.props.id
              ? link.props.id
              : `0_${String(index)}`;

          return <Fragment key={key}>{link}</Fragment>;
        })}
      </ul>
    );
  };

  /**
   * @name renderBrandingLogo
   * @summary menu link wrapper for Branding Logo
   */
  const renderBrandingLogo = () => (
    <Link
      to={{ pathname: '/', search: getQueryString() }}
      className="branding-logo"
      onClick={onMenuItemClick}
    />
  );

  /**
   * @name renderUserBox
   * @summary dropdown menu clicked on user profile
   */
  const renderUserBox = () => {
    if (showUserBox) {
      if (window.innerWidth > MOBILE_WIDTH_POINT) {
        return (
          <UserBox
            member={member}
            linkData={userBoxLinks}
            renderRewardPoints={renderRewardPoints}
            renderLotteriesLink={renderLotteriesLink}
            onSignOutClick={onSignOutClick}
            onUserBoxItemClick={onUserBoxItemClick}
            onCancelClick={onProfileIconClick}
          />
        );
      }
      return (
        <MobileSideBar
          member={member}
          linkData={userBoxLinks}
          renderRewardPoints={renderRewardPoints}
          renderLotteriesLink={renderLotteriesLink}
          onSignOutClick={onSignOutClick}
          onUserBoxItemClick={onUserBoxItemClick}
          onClose={onProfileIconClick}
          isOpen={showUserBox}
        />
      );
    }
    return <div />;
  };

  /**
   * @name renderRewardPoints
   * @summary menu link wrapper for fun points
   */
  const renderRewardPoints = () => {
    const balance = funPoints?.total ?? 0;
    return (
      <li className="user-header-link">
        <Link to="/me/rewards/history" onClick={onUserBoxItemClick}>
          <span className="reward-points-coin" style={{ marginRight: '4px' }} />
          <FormattedNumber value={balance} />
          <span>&nbsp;Fun Points</span>
        </Link>
      </li>
    );
  };

  const renderLotteriesLink = () => {
    if (isTW || isJA) {
      return (
        <div className="lotteries-link">
          <MenuLink
            id="LOTTERIES_ID"
            isCurrent={false}
            isExternal={false}
            path={MY_REFERRAL_PAGE}
            textId="Referral"
            onClick={onUserBoxItemClick}
          />
          <div className="tag">New</div>
        </div>
      );
    }

    return null;
  };

  return (
    <header className={isLogin ? 'branding' : 'islogout branding'}>
      {renderBrandingLogo()}
      <SearchHeader />
      <nav className={showMenu ? 'toggle-on' : ''}>
        <div
          role="button"
          tabIndex={0}
          className="nav-toggle"
          onClick={onMenuClick}
          onKeyDown={onMenuClick}
        >
          <img src={require('../images/common/icon_menu.png')} alt="menu" />
        </div>
        {renderHeaderMenu()}
      </nav>
      {renderUserBox()}
    </header>
  );
};

export default Header;
